










import { State } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'

import Loading from '@/components/Loading'
import Error from '@/components/Error'

import './app.less'

@Component({
  components: {
    Loading,
    Error
  }
})
class App extends Vue {
  // 错误和主内容的显示是互斥的，所以错误是否显示暂时放在这里进行控制，后续有问题再调整
  @State(state => state.error.isShow) showError!: boolean
}

export default App
